const PASCAL_BLACK_MARKET_CONTRACT_ADDRESS = "0x50ae01eC60059B60b6F36f4723c939Cb8FaaaC05";

export {
  PASCAL_BLACK_MARKET_CONTRACT_ADDRESS
};